import { LOGOUT } from "./types";
import { clearLocalStorage } from "../services/LocalStorageService";

export const logout = () => {
  clearLocalStorage();
  return {
    type: LOGOUT,
  };
};
